import React from 'react';

 
const Landing = () => (
    <div>Landing</div>
);
 
export default Landing;